export default {
  toasts: {
    failed_to_create_website: 'Nie udało się utworzyć strony',
  },
  steps: {
    information: 'Informacje',
    template: 'Szablon',
  },
  buttons: {
    next: 'Dalej',
    previous: 'Wstecz',
    create_website: 'Utwórz stronę',
    preview_about_us: 'O nas (podgląd)',
  },
  about_us_modal: {
    title: 'O nas (podgląd)',
  },
  error_messages: {
    missing_fields: 'Brakuje niektórych wymaganych pól. Uzupełnij wszystkie niezbędne informacje przed kontynuowaniem.',
  },
};
